import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { filter, take } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ToastModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly document = inject(DOCUMENT);
  private readonly router = inject(Router);

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd | NavigationCancel | NavigationError =>
            event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError,
        ),
        take(1),
      )
      .subscribe(() => this.hideInitialLoader());
  }

  private hideInitialLoader(): void {
    const loader = this.document.getElementById('lisa-app-loader');

    if (!loader || loader.classList.contains('lisa-app-loader--hidden')) {
      return;
    }

    loader.classList.add('lisa-app-loader--hidden');
    //  window.setTimeout(() => loader.remove(), 1);
  }
}
